export default __webpack_public_path__ + "static/media/enroll.8a9d5bfc.png";